import { createElementBlock as o, openBlock as i, normalizeClass as l, Fragment as c, renderList as m, createVNode as d, unref as p } from "vue";
import u from "../link/link.vue.js";
import { themeProp as b } from "../../composables/useTheme.js";
import { useTracking as _ } from "../../composables/useTracking.js";
/* empty css                */
import f from "../../_virtual/_plugin-vue_export-helper.js";
const n = "DsSocialBar", k = /* @__PURE__ */ Object.assign({
  name: n
}, {
  __name: "social-bar",
  props: {
    ...b,
    /**
     * SocialBar items
     */
    items: {
      type: Array,
      required: !0,
      validator: (a) => a.every((t) => typeof t == "object" && ["src", "name"].every((r) => r in t))
    },
    /**
     * SocialBar items position
     */
    disposition: {
      type: String,
      default: "vertical",
      validator: (a) => ["vertical", "horizontal"].includes(a)
    }
  },
  setup(a) {
    const { trackingDataProvided: t } = _();
    return (r, y) => (i(), o("ul", {
      class: l(["ds-social-bar", [`ds-social-bar--${r.theme} ds-social-bar--${a.disposition}`]]),
      role: "menubar",
      "data-j-socialbar-list": ""
    }, [
      (i(!0), o(c, null, m(a.items, (e, s) => (i(), o("li", {
        key: `social-bar-item-${s}`,
        class: "ds-social-bar__list-item",
        role: "none"
      }, [
        d(u, {
          "tracking-data": {
            "component-name": n,
            text: e.text,
            id: e.iconName,
            ...p(t)
          },
          content: { category: "extra-24", name: `${e.iconName}-small`, ariaLabel: e.text },
          url: e.url,
          "open-in-new-window": "",
          role: "menuitem",
          class: "ds-social-bar__link",
          type: "button",
          "data-j-socialbar-list-link": ""
        }, null, 8, ["tracking-data", "content", "url"])
      ]))), 128))
    ], 2));
  }
}), B = /* @__PURE__ */ f(k, [["__scopeId", "data-v-4e265264"]]);
export {
  B as default
};
